import {
  defaultFont,
  container,
  primaryColor,
  borderSubtleColor,
  textMutedColor,
} from 'assets/jss/material-dashboard-react';

const footerStyle = {
  block: {
    color: 'inherit',
    padding: '15px',
    textTransform: 'none',
    borderRadius: '8px',
    textDecoration: 'none',
    position: 'relative',
    display: 'block',
    ...defaultFont,
    fontWeight: '500',
    fontSize: '12px',
  },
  left: {
    float: 'left!important',
    display: 'block',
  },
  right: {
    padding: '12px 0',
    margin: '0',
    fontSize: '13px',
    float: 'right!important',
    color: textMutedColor,
  },
  footer: {
    bottom: '0',
    borderTop: `1px solid ${borderSubtleColor}`,
    padding: '12px 0',
    ...defaultFont,
    backgroundColor: 'transparent',
  },
  container,
  a: {
    color: primaryColor,
    textDecoration: 'none',
    backgroundColor: 'transparent',
    fontWeight: 500,
  },
  list: {
    marginBottom: '0',
    padding: '0',
    marginTop: '0',
  },
  inlineBlock: {
    display: 'inline-block',
    paddingTop: '0px',
    width: 'auto',
  },
};
export default footerStyle;
